import React, { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Header from '../Header';
import Footer from '../Footer';
import './index.css';

const photos = [
  { src: '/certificates/staticCerti.jpg', alt: 'Static Website Certificate' },
  { src: '/certificates/python.jpg', alt: 'Python Certificate' },
  { src: '/certificates/responsivewebsite.jpg', alt: 'Responsive Website Certificate' },
  { src: '/certificates/dynamicwebsite.jpg', alt: 'Dynamic Website Certificate' },
  { src: '/certificates/sqlDB.jpg', alt: 'SQL Database Certificate' },
  { src: '/certificates/JSEssential.jpg', alt: 'JavaScript Essentials Certificate' },
  { src: '/certificates/flexbox.jpg', alt: 'Flexbox Certificate' },
  { src: '/certificates/developerfoundations.jpg', alt: 'Developer Foundations Certificate' },
  { src: '/certificates/NodeJS.jpg', alt: 'Node.js Certificate' },
  { src: '/certificates/ReactJs.jpg', alt: 'React.js Certificate' },
  { src: '/certificates/pyhtonForDataScience.jpg', alt: 'Python for Data Science Certificate' },
  { src: '/certificates/PythonForDataScience2.jpg', alt: 'Python for Data Science 2 Certificate' },
];

const workshops = [
  {
    name: 'Gen AI Mega Workshop',
    organized_By: 'NxtWave',
    date: '7-08-2023',
    skills: 'General Concepts of Gen AI, LLMs',
    participation: '/certificates/GenAiMegaParticipation.jpg',
    projectCompletion: '/certificates/GenAiMegaProjectCompletion.jpg',
  },
  {
    name: 'Ethical Hacking Mega Workshop',
    organized_By: 'NxtWave',
    date: '5-10-2023',
    skills: 'General Concepts of Ethical Hacking',
    participation: '/certificates/EthicalHackParticipation.jpg',
    projectCompletion: '/certificates/EthicalHackProject.jpg',
  },
  {
    name: 'Data Analytics Mega Workshop',
    organized_By: 'NxtWave',
    date: '31-01-2024',
    skills: 'Data Analyst fundamentals and Power BI',
    participation: '/certificates/DataAnalyticsParticipation.jpg',
    projectCompletion: '/certificates/DataAnalyticsProject.jpg',
  },
  {
    name: 'AWS Mega Workshop',
    organized_By: 'NxtWave',
    date: '13-06-2024',
    skills: 'Cloud computing and AWS key services',
    participation: '/certificates/AWSParticipation.jpg',
    projectCompletion: '/certificates/AWSProject.jpg',
  },
  {
    name: 'Generative AI Mega Workshop 2.0',
    organized_By: 'NxtWave',
    date: '18-09-2024',
    skills: 'General Concepts of Gen AI',
    participation: '/certificates/GenerativeAi2participation.jpg',
    projectCompletion: '/certificates/GenerativeAi2Project.jpg',
  },
  {
    name: 'UI/UX Mega Workshop 2.0',
    organized_By: 'NxtWave',
    date: '22-10-2024',
    skills: 'UI/UX Fundamentals, Figma Expertise',
    participation: '/certificates/UIUXParticipation.jpg',
    projectCompletion: '/certificates/UIUXProject.jpg',
  },
];

const Certificates = () => {
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <div className="main-container">
      <Header />
      <div className="page-content">
        <h2 className="section-heading">Certifications</h2>
        <p className="section-subheading">
          Professional certifications and workshop completions from my learning journey.
        </p>

        <div className="certificates-grid">
          {photos.map((photo, index) => (
            <button
              key={index}
              type="button"
              className="certificate-thumb glass-card"
              onClick={() => {
                setCurrentIndex(index);
                setOpen(true);
              }}
            >
              <img src={photo.src} alt={photo.alt} className="certificate-image" />
              <span className="certificate-overlay">View</span>
            </button>
          ))}
        </div>

        <h3 className="workshops-heading">Workshops</h3>
        <div className="workshops-grid">
          {workshops.map((eachWorkShop, index) => (
            <article key={index} className="workshop-card glass-card">
              <h4 className="workshop-title">{eachWorkShop.name}</h4>
              <div className="workshop-meta">
                <span><strong>Organized by:</strong> {eachWorkShop.organized_By}</span>
                <span><strong>Date:</strong> {eachWorkShop.date}</span>
              </div>
              <p className="workshop-skills">
                <strong>Skills:</strong> {eachWorkShop.skills}
              </p>
              <div className="workshop-certificates">
                <img src={eachWorkShop.participation} className="workshop-cert-img" alt="Participation certificate" />
                <img src={eachWorkShop.projectCompletion} className="workshop-cert-img" alt="Project completion certificate" />
              </div>
            </article>
          ))}
        </div>
      </div>

      <Lightbox open={open} close={() => setOpen(false)} slides={photos} index={currentIndex} />
      <Footer />
    </div>
  );
};

export default Certificates;
